import React from 'react';
import Image from 'next/image';

import { CSex } from '@/models/userInput';

interface IProps {
    age?: number;
    sex?: number;
    width: number | string;
    height: number | string;
}

const baseUrl = '/img/profile_image/';
const extension = '@3x.png';

function FCThumbnail({ age, sex, width, height }: IProps) {
    if (age === undefined || sex === undefined) {
        return <Image src={`${baseUrl}nonMember${extension}`} width={width} height={height} alt="fc_thumbnail" />;
    }

    const getGeneration = () => {
        if (age >= 20 && age < 34) {
            return 'profile_2030';
        }
        if (age >= 34 && age < 44) {
            return 'profile_3040';
        }
        if (age >= 44 && age < 60) {
            return 'profile_4050';
        }
        if (age >= 60) {
            return 'profile_6070';
        }
    };

    const getSex = () => {
        if (sex === CSex.MALE) {
            return '_m';
        }
        return '_w';
    };

    const src = baseUrl + getGeneration() + getSex() + extension;

    return <Image src={src} width={width} height={height} alt="fc_thumbnail" />;
}

export default FCThumbnail;
